import { Component, inject, OnInit } from '@angular/core';

import { HlmAlertDialogModule } from "../../../../../../spartan_libs/ui-alertdialog-helm/src/index";
import { HlmDialogHeaderComponent } from "../../../../../../spartan_libs/ui-dialog-helm/src/lib/hlm-dialog-header.component";
import { HlmDialogFooterComponent } from "../../../../../../spartan_libs/ui-dialog-helm/src/lib/hlm-dialog-footer.component";
import { HlmDialogComponent } from "../../../../../../spartan_libs/ui-dialog-helm/src/lib/hlm-dialog.component";
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/ui-dialog-brain';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    CommonModule,
    HlmAlertDialogModule, 
    HlmDialogHeaderComponent, 
    HlmDialogFooterComponent, 
    HlmDialogComponent
  ],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent implements OnInit {

  private readonly _dialogRef = inject<BrnDialogRef<any>>(BrnDialogRef);
  private readonly _dialogContext = injectBrnDialogContext<{ data: any}>();
  protected readonly data = this._dialogContext.data;

  constructor(){}

  ngOnInit(): void {
  }

  closeDialog(): void{
    if(this.data?.closeData){
      this._dialogRef.close(this.data?.closeData);
    }else{
      this._dialogRef.close(false);
    }
  }

  cancelDialog(): void {
    this._dialogRef.close(false);
  }

  submitDialog(): void {
    this._dialogRef.close(true);
  }
  
}
